import type { FilterProperty } from '@/components/admin/SysadminSPA/shared/filterTypes';

// AIDEV-NOTE: Ransack filter properties for the Alert Messages table. `type` is the STI column
// (InfoBar = "Alert Bar", HeaderNotification = "What's New"), `kind` the program/lesson scope.
const ALERT_MESSAGE_FILTER_PROPERTIES: FilterProperty[] = [
  {
    label: 'Scope',
    operators: ['eq'],
    options: [
      { label: 'Program Specific', value: 'program' },
      { label: 'Lesson Specific', value: 'lesson' },
    ],
    value: 'kind',
  },
  {
    label: 'Type',
    operators: ['eq'],
    options: [
      { label: 'Alert Bar', value: 'InfoBar' },
      { label: "What's New", value: 'HeaderNotification' },
    ],
    value: 'type',
  },
  {
    label: 'Category',
    operators: ['eq'],
    options: [
      { label: 'Content', value: 'Content' },
      { label: 'Marketing', value: 'Marketing' },
    ],
    value: 'category',
  },
  {
    label: 'Program',
    operators: ['eq', 'not_eq'],
    value: 'programs_id',
  },
  {
    label: 'Location',
    operators: ['eq'],
    value: 'location',
  },
  {
    label: 'State',
    operators: ['eq'],
    value: 'states_id',
  },
  {
    isBoolean: true,
    label: 'For reviewers only',
    operators: ['eq'],
    value: 'for_review_only',
  },
  {
    isBoolean: true,
    label: 'Published',
    operators: ['eq'],
    value: 'publish',
  },
  {
    label: 'Title',
    operators: ['eq', 'cont', 'not_cont'],
    value: 'title',
  },
];

export default ALERT_MESSAGE_FILTER_PROPERTIES;
